import { differenceInDays, endOfDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { InsightsTimeframes } from 'shared/types/insights';
import { Timestamp } from 'shared/types/timestamp';

export type Options = {
  startDate: Timestamp;
  endDate: Timestamp;
};

export const useInsightsTimeframeByTime = ({ startDate, endDate }: Options) => {
  const timeframe = useMemo(() => {
    const dayDiff = differenceInDays(endOfDay(endDate), startOfDay(startDate));

    if (dayDiff > 26 * 7) {
      return InsightsTimeframes.Year;
    }

    if (dayDiff > 12 * 7) {
      return InsightsTimeframes.Quarter;
    }

    if (dayDiff >= 7) {
      return InsightsTimeframes.Month;
    }

    return InsightsTimeframes.Week;
  }, [endDate, startDate]);

  return {
    referenceDate: startDate,
    timeframe,
  };
};
